
// export default LoginPage;
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@mui/material';
import eyefill from '../../public/eye-fill.svg';
import eyeclose from '../../public/eye-slash-fill.svg';

import { userLogin } from '../../redux/user/actionCreator';
import {
  resendVerification,
  setUsernameApi,
} from '../../services/verification.js';
import { validateEmail, validateUserName } from '../../utils/validation';
import "react-tabs/style/react-tabs.css";
import Meta from "../../components/Meta";
import { Metamask_comp_login } from "../../components/metamask/Metamask";
import Image from "next/image";
import WhiteLogo from "./../../public/logo/only-text-logo.png";
import WhiteIconLogo from "./../../public/images/Ico-LOGO/white.png";
import LoginWithGoogle from '../../components/LoginWithGoogle.jsx';
const LoginPage = ({ params }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const [openUsername, setOpenUsername] = useState(false);
  const [data, setData] = useState({
    email: {
      value: '',
      error: '',
    },
    password: {
      value: '',
      error: '',
    },
  });
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState({
    value: '',
    error: '',
  });

  useEffect(() => {
    if (router.query.success === 'true') {
      setOpen(true);
    } else if (router.query.success === 'false') {
      setOpenUsername(true);
    }
  }, [router.query.success]);

  const onLogin = (e) => {
    // document.querySelector('.overlay').style.display = 'block';

    e.preventDefault();
    if (validateEmail(data.email.value) || validateUserName(data.email.value)) {
      dispatch(
        userLogin(
          {
            emailOrUsername: data.email.value,
            password: data.password.value,
          },
          () => router.push('/dashboard'), setOpen, params
        )
      );
    } else {
      setData((prev) => ({
        email: {
          ...prev.email,
          error:
            prev.email.value === ''
              ? 'Email or Username is required'
              : validateEmail(prev.email.value) ||
                validateUserName(prev.email.value)
                ? ''
                : 'Email or Username is required',
        },
        password: {
          ...prev.password,
          error:
            prev.password.value === ''
              ? 'Password is required'
              : validateEmail(prev.email.value) ||
                validateUserName(prev.email.value)
                ? ''
                : 'Password is required',
        },
      }));
    }
  };

  return (
    <div className='loginContainer'>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>{'Email verification'}</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Please verify your email =&gt; {router.query.email} to login
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>discard</Button>
          <Button
            onClick={() => {
              setOpen(false);
              dispatch(resendVerification(router.query.email));
            }}
            autoFocus
          >
            Resend
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openUsername}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>{router.query.message}</DialogTitle>
        <DialogContent
          sx={{
            width: '100%',
          }}
        >
          <input
            type='text'
            id='username'
            label={'Username'}
            placeholder='Username'
            inputValue={username}
            onChange={(e) =>
              setUsername({
                value: e.target.value,
                error: validateUserName(e.target.value)
                  ? ''
                  : 'Invalid username',
              })
            }
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              if (router.query.tempToken) {
                setOpenUsername(false);
                setUsernameApi(
                  username.value,
                  router.query.tempToken,
                  () => router.push('/dashboard') // Adjust the route accordingly
                );
              } else {
                setOpenUsername(false);
                setUsernameApi(username.value, () => router.push('/dashboard')); // Adjust the route accordingly
              }
            }}
            autoFocus
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Meta title="Sign In || Impactoverse " />
      {/* <!-- Signin --> */}
      <section className="relative">
        <div className="lg:flex lg:h-full">
          {/* <!-- Left --> */}
          <div className="relative text-center lg:w-1/2">
            <Image
              width={768}
              height={722}
              src="/images/login.jpg"
              alt="login"
              className="absolute h-full w-full object-cover"
            />
            {/* <!-- Logo --> */}

            <div className="relative inline-block py-36 px-5">
              <Link href="/" className="relative">
                <div>
                  <Image
                    src={WhiteIconLogo}
                    height={42}
                    width={195}
                    className="mx-auto flex top-0 z-10 bg-blue-500 rounded-md animate-spin-faux3d"
                    alt="Impactoverse | Impact Ecosystem"
                  />
                </div>
              </Link>
              <Link href="/" className="relative ">
                <div>
                  <Image
                    src={WhiteLogo}
                    height={100}
                    width={400}
                    className="mx-auto flex top-0 z-10 bg-blue-500 rounded-md animate-spin-faux3d "
                    alt="Impactoverse | Impact Ecosystem"
                  />
                </div>
              </Link>
            </div>
          </div>

          {/* <!-- Right --> */}
          <div className="relative flex items-center justify-center p-[10%] lg:w-1/2">
            <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
              <Image
                width={1519}
                height={773}
                priority
                src="/images/gradient_light.jpg"
                alt="gradient"
                className="h-full w-full object-cover"
              />
            </picture>

            <div className="w-full max-w-[25.625rem] text-center">
              <h2 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase pb-0 mb-0">
                Sign in
              </h2>
              <p className="text-lg dark:text-jacarta-300 mb-6 leading-normal">
                Don&apos;t have account?
                <Link href="/sign-up" className="text-accent">
                  {" "}
                  SIGN UP
                </Link>
              </p>
              <form id="contact-form" method="post">
                <div className="mb-4">
                  <label className="mb-1 flex items-center space-x-2 dark:text-jacarta-200 text-sm text-left uppercase">
                    Email / Username<span className="text-red">*</span>
                  </label>
                  <input
                    id="email"
                    className="contact-form-input dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white"
                    required
                    inputValue={data.email}
                    onChange={(e) =>
                      setData({
                        ...data,
                        email: {
                          value: e.target.value,
                          error:
                            validateEmail(e.target.value) ||
                              validateUserName(e.target.value)
                              ? ''
                              : 'Email or Username is required',
                        },
                      })
                    }
                    name="email"
                    type="email"
                  />
                </div>
                <div className="mb-4">
                  <label className="mb-1 flex items-center space-x-2 dark:text-jacarta-200 text-sm text-left uppercase">
                    Password<span className="text-red">*</span>
                  </label>
                  <div className=' relative'>
                    <input
                      id="password"
                      className="contact-form-input dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white"
                      required
                      name="password"
                      type={showPassword ? 'text' : 'password'}
                      inputValue={data.password}
                      onChange={(e) =>
                        setData({
                          ...data,
                          password: {
                            value: e.target.value,
                            error: e.target.value !== '' ? '' : 'Password is required',
                          },
                        })
                      }
                    />
                    <span className="toggle-btn" onClick={() =>
                      setShowPassword(
                        !showPassword
                      )
                    }>
                      {showPassword ? <Image src={eyeclose} alt="show" width={50} height={30} /> : <Image src={eyefill} width={50} height={30} alt="close" />}
                    </span>
                  </div>
                </div>

                <div className=" flex items-center space-x-2">
                  <p className="text-lg dark:text-jacarta-300 mb-10 leading-normal">
                    <Link href="/forget-password" className="text-accent">
                      {" "}
                      Forgot Password?
                    </Link>
                  </p>
                </div>

                <button onClick={onLogin} className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 dark:hover:bg-accent hover:bg-accent font-semibold mb-4 flex w-full items-center justify-center rounded-full border-2 bg-white py-4 px-8 text-center transition-all hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent uppercase">
                  <span>SIGN IN</span>
                </button>
                {/* <button className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 dark:hover:bg-accent hover:bg-accent font-semibold mb-4 flex w-full items-center justify-center rounded-full border-2 bg-white py-4 px-8 text-center transition-all hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent uppercase">
                  <span>SIGN IN WITH GOOGLE</span>
                </button> */}
                <LoginWithGoogle method={'Sign '} />

                <Metamask_comp_login />
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LoginPage;
